export function getUserLocale() {
    const HTMLDocument = document.querySelector('html');

    if (HTMLDocument.getAttribute('lang') && HTMLDocument.getAttribute('country')) {
        return `${HTMLDocument.getAttribute('lang') }-${HTMLDocument.getAttribute('country').toUpperCase()}`;
    }

    return null;
}

export function getNumberWithDecimals({ number, numberOfDecimals }) {
    return number !== null && !Number.isNaN(number) ? Number(number).toFixed(numberOfDecimals) : '';
}

export function getNumberFormat(number) {
    return number !== null && !Number.isNaN(number) && getUserLocale() !== null ? new Intl.NumberFormat(getUserLocale()).format(number) : number;
}
